const ACCESS_KEY = "merchant_portal_access_token";
const REFRESH_KEY = "merchant_portal_refresh_token";
const EXPIRES_KEY = "merchant_portal_expires_at";

export const CHALLENGE_KEY = "merchant_portal_challenge_id";
export const MASKED_PHONE_KEY = "merchant_portal_masked_phone";

export function getPortalTokens() {
  const access_token = localStorage.getItem(ACCESS_KEY) || "";
  const refresh_token = localStorage.getItem(REFRESH_KEY) || "";
  const expiresRaw = localStorage.getItem(EXPIRES_KEY);
  const expires_at = expiresRaw ? Number(expiresRaw) : 0;
  return { access_token, refresh_token, expires_at };
}

export function setPortalTokens({ access_token, refresh_token, expires_in }) {
  if (access_token) {
    localStorage.setItem(ACCESS_KEY, access_token);
  }
  if (refresh_token) {
    localStorage.setItem(REFRESH_KEY, refresh_token);
  }
  if (expires_in != null) {
    const expires_at = Date.now() + Number(expires_in) * 1000;
    localStorage.setItem(EXPIRES_KEY, String(expires_at));
  }
}

export function clearPortalTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(EXPIRES_KEY);
}

export function isPortalAccessExpired(expires_at, skewMs = 60_000) {
  if (!expires_at) return true;
  return Date.now() >= expires_at - skewMs;
}

export function setOtpChallenge(challenge_id, masked_phone) {
  sessionStorage.setItem(CHALLENGE_KEY, challenge_id);
  if (masked_phone) {
    sessionStorage.setItem(MASKED_PHONE_KEY, masked_phone);
  }
}

export function getOtpChallenge() {
  return {
    challenge_id: sessionStorage.getItem(CHALLENGE_KEY) || "",
    masked_phone: sessionStorage.getItem(MASKED_PHONE_KEY) || "",
  };
}

export function clearOtpChallenge() {
  sessionStorage.removeItem(CHALLENGE_KEY);
  sessionStorage.removeItem(MASKED_PHONE_KEY);
}
